import React from 'react';
import { Link } from 'react-router-dom';
import NotificationItem from './NotificationItem';
import './NotificationDropdown.css';

const NotificationDropdown = ({ 
  notifications, 
  isLoading, 
  error,
  onNotificationClick, 
  onMarkAllAsRead, 
  onClose 
}) => {
  const formatTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);

    if (diffInSeconds < 60) {
      return 'Just now';
    } else if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      return `${minutes}m ago`;
    } else if (diffInSeconds < 86400) {
      const hours = Math.floor(diffInSeconds / 3600);
      return `${hours}h ago`;
    } else {
      const days = Math.floor(diffInSeconds / 86400);
      return `${days}d ago`;
    }
  };

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'PURCHASE_WON':
        return '★';
      case 'CREDIT_ADDED':
        return '$';
      case 'PLAYER_PURCHASED':
        return '✓';
      case 'PLAYER_REMOVED':
        return '×';
      case 'PLAYER_SOLD':
        return '↗';
      case 'TOURNAMENT_COMPLETED':
        return '🏆';
      case 'ROUND_UPDATE':
        return '●';
      default:
        return '•';
    }
  };

  const handleNotificationClick = (notification) => {
    onNotificationClick(notification.id);
    onClose();
  };

  const handleMarkAllAsRead = () => {
    onMarkAllAsRead();
    onClose();
  };

  return (
    <div className="notification-dropdown">
      <div className="notification-dropdown-header">
        <h3>Notifications</h3>
        {(notifications || []).length > 0 && (
          <button 
            className="mark-all-read-btn"
            onClick={handleMarkAllAsRead}
            title="Mark all as read"
          >
            Mark all read
          </button>
        )}
      </div>

      <div className="notification-dropdown-content">
        {isLoading ? (
          <div className="notification-loading">
            <div className="loading-spinner"></div>
            <span>Loading notifications...</span>
          </div>
        ) : error ? (
          <div className="notification-error">
            <div className="error-icon">!</div>
            <p>Failed to load notifications</p>
            <span>Please try again later</span>
          </div>
        ) : (notifications || []).length === 0 ? (
          <div className="notification-empty">
            <div className="empty-icon">•</div>
            <p>No notifications yet</p>
            <span>We'll notify you when something important happens</span>
          </div>
        ) : (
          <div className="notification-list">
            {(notifications || []).map((notification) => (
              <NotificationItem
                key={notification.id}
                notification={notification}
                icon={getNotificationIcon(notification.type)}
                timeAgo={formatTimeAgo(notification.createdAt)}
                isRead={notification.readStatus}
                onClick={() => handleNotificationClick(notification)}
              />
            ))}
          </div>
        )}
      </div>

      {(notifications || []).length > 0 && (
        <div className="notification-dropdown-footer">
          <Link 
            to="/notifications" 
            className="view-all-link"
            onClick={onClose}
          >
            View all notifications
          </Link>
        </div>
      )}
    </div>
  );
};

export default NotificationDropdown;
